import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

import { CrudPlantillasModal } from 'sharedComponents/modals'

const PlantillaFormGroup = ({ iOrigen, iError, iTouched, fIsSubmitting, setFieldValue, vTipoDocumento }) => {
  const [plantillasOptions, setPlantillasOptions] = React.useState([])
  const [mostrarCrudPlantillaModal, setMostrarCrudPlantillaModal] = React.useState(false)

  const refrescarSelect = React.useCallback(() => {
    PlantillaContabilidadService.getxOrigenAsSelect(iOrigen).then(({ data }) => {
      if (data && data.length > 0) {
        const primeraOpcion = data[0]
        setFieldValue('_idPlantilla', primeraOpcion._id)

        setPlantillasOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.descripcion}
            </option>
          ))
        )
      }
    })
  }, [iOrigen, setFieldValue])

  React.useEffect(() => {
    refrescarSelect()
  }, [refrescarSelect])

  const onKeyDown = React.useCallback(
    e => {
      if (vTipoDocumento === '50' || vTipoDocumento === '52') {
        KeyEventUtil.leaveOnEnterOrTab('input-anioAduana', e)
      } else if (vTipoDocumento === '03') {
        KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumentoFin', e)
      } else {
        KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
      }
    },
    [vTipoDocumento]
  )

  return (
    <>
      <Form.Group>
        <Col md={12}>
          <Form.InputGroup>
            <Field name='_idPlantilla'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  id='select-plantilla'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting}
                  onKeyDown={onKeyDown}
                >
                  <option value=''>Seleccionar</option>
                  {plantillasOptions}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarCrudPlantillaModal(true)}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarCrudPlantillaModal && (
        <CrudPlantillasModal
          handleClose={() => {
            setMostrarCrudPlantillaModal(false)
            refrescarSelect()
          }}
          origen={iOrigen}
          show={mostrarCrudPlantillaModal}
        />
      )}
    </>
  )
}

export default React.memo(PlantillaFormGroup)
